export function DropdownScrollPlugin() {
  const tomSelect = this
  const scrollIndicator = document.createElement("scroll-indicator")
  scrollIndicator.setAttribute("tolerance", 12)

  tomSelect.hook('after','setup', () => {
    tomSelect.dropdown.insertBefore(scrollIndicator, tomSelect.dropdown_content)

    scrollIndicator.appendChild(tomSelect.dropdown_content)
  })

  tomSelect.hook("after", "refreshOptions", () => {
    scrollIndicator.displayIndicators()
  })

  tomSelect.hook("instead", "scrollToOption", (option, behavior) => {
    if (!option) {
      return
    }

    option.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: behavior
    })
  })
}
